/**
 * Lumenate sticky header state driver.
 *
 * Horizon pins the header with CSS and toggles its "scrolled" look from
 * header.js, which reads document.scrollingElement.scrollTop. But on desktop
 * (>=990px) Horizon locks html/body to overflow:hidden and scrolls the inner
 * .page-wrapper instead — so document.scrollingElement never moves and the
 * header's scrolled state never activates.
 *
 * This bridges that gap: it watches whichever element actually scrolls
 * (.page-wrapper on desktop, the document elsewhere) and toggles a
 * `data-scrolled` attribute on #header-component past a small threshold.
 * The frosted-bar styling keys off that attribute (see lumenate-foundations).
 *
 * Kept separate from header.js so a theme update can't clobber it and it can't
 * race Horizon's own data-sticky-state logic (it uses a distinct attribute).
 */
(() => {
  const THRESHOLD = 40;

  function setup() {
    const header = document.getElementById('header-component');
    if (!header) return;
    // The frosted bar is the scrolled state of a *pinned* header. Horizon only sets
    // [sticky] when the merchant picked Always / Scroll up, so "Never" stays never.
    if (!header.hasAttribute('sticky')) return;

    const pageWrapper = document.querySelector('.page-wrapper');
    let ticking = false;

    function currentScrollTop() {
      const wrapperTop = pageWrapper ? pageWrapper.scrollTop : 0;
      const docTop = document.scrollingElement ? document.scrollingElement.scrollTop : 0;
      // Only one of these moves at a time depending on viewport; take the larger.
      return Math.max(wrapperTop, docTop);
    }

    function update() {
      ticking = false;
      header.toggleAttribute('data-scrolled', currentScrollTop() > THRESHOLD);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    if (pageWrapper) pageWrapper.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
